import { render, staticRenderFns } from "./inputNumber.vue?vue&type=template&id=28cf78c9&scoped=true"
import script from "./inputNumber.vue?vue&type=script&lang=js"
export * from "./inputNumber.vue?vue&type=script&lang=js"
import style0 from "./inputNumber.vue?vue&type=style&index=0&id=28cf78c9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cf78c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28cf78c9')) {
      api.createRecord('28cf78c9', component.options)
    } else {
      api.reload('28cf78c9', component.options)
    }
    module.hot.accept("./inputNumber.vue?vue&type=template&id=28cf78c9&scoped=true", function () {
      api.rerender('28cf78c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/platList/components/inputNumber.vue"
export default component.exports